import React from "react";
import Image from "next/image";
import dayjs from "dayjs";
import { getImageSrc } from "@/app/utils/getImageSrc";
export const AwardCard = ({ award }) => {
	return (
		<div className="border border-[#D6D6D6] p-4 rounded-[15px]">
			<Image alt={award.image?.alt || award.title} src={getImageSrc(award.image.url)} width={30} height={30} unoptimized className="object-contain w-full mb-5" />
			<div className="flex flex-col gap-2">
				<h3 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-bold">{award.title}</h3>
				<div className="text-[14px] lg:text-[16px] xl:text-[18px]  flex items-start justify-start gap-2">
					<h5 className="font-bold">Awarded By </h5>
					<span className="text-gray">{award.name}</span>
				</div>
				<div className="text-[14px] lg:text-[16px] xl:text-[18px]  flex items-start justify-start gap-2">
					<h5 className="font-bold">Category </h5>
					<span className="text-gray">{award.category}</span>
				</div>
				<div className="text-[14px] lg:text-[16px] xl:text-[18px] flex items-start justify-start gap-2">
					<h5 className="font-bold">Year </h5>
					<span className="text-gray">{dayjs(award.awardDate).format("YYYY")}</span>
				</div>
			</div>
		</div>
	);
};
